import {Injectable} from '@angular/core';
import {ApiService} from '@app/shared/services/api.service';
import {Observable} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private api: ApiService) {
  }

  checkCredentials(params: any): Observable<any> {
    return this.api.post('Login/checkCredentials', params)
  }

  getAccessTypes(): Observable<any> {
    return this.api.post('Login/getAccessTypes', null)
  }

  getInstitution(): Observable<any> {
    return this.api.post('InstitutionManagement/listInstitution', null)
  }
}
